import {alpha} from "@mui/material/styles";
import { getAssetsUrl } from '../../utils/@helper/file.helper';

// ==============================|| MENU OVERRIDES ||============================== //

export default function Menu(theme) {
    return {
        MuiMenu: {
            styleOverrides: {
                paper: {
                    borderRadius: 0,
                    padding: theme.spacing(0.5),
                    backdropFilter: 'blur(20px)',
                    // backgroundColor: 'rgba(255, 255, 255, 0.9)',
                    backgroundRepeat: 'no-repeat, no-repeat',
                    backgroundPosition: 'right top, left bottom',
                    backgroundSize: '50%, 50%',
                    // backgroundImage: `url('${getAssetsUrl('images/cyan-blur.png')}'), url('${getAssetsUrl('images/red-blur.png')}')`,
                },
                list: {
                    '&::not(:last-of-type)': {}
                }
            }
        },
        MuiMenuItem: {
            styleOverrides: {
                root: {
                    '&:not(:last-of-type)': {
                        marginBottom: theme.spacing(0.5)
                    },
                    '&:hover': {
                        backgroundColor: '#F5F6FF',
                        // backgroundColor: rgba(145, 158, 171, 0.08);
                        // backgroundColor: alpha(theme.palette.grey[500], 0.08),
                    },
                    '&.Mui-selected': {
                        // fontWeight: 700,
                        color: theme.palette.color.primaryBlue3,
                        backgroundColor: '#F5F6FF',
                    }
                },
                selected: {
                    backgroundColor: alpha(theme.palette.grey[500], 0.08),
                }
            }
        }
    };
}
